export const additionalPriceInfo = () => {
  const additionalPriceInfo = document.querySelector(
    ".woocommerce-additional-price-info"
  );

  if (additionalPriceInfo) {
    jQuery(document).on("yith-wapo-after-reload-addons", function () {
      const yithWapoBlock = document.querySelector(".yith-wapo-block");
      additionalPriceInfo.style.display = yithWapoBlock ? "none" : "flex";
    });
  }
};
